var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{class:_vm.$style.container},[(_vm.isVideo)?_c('a',{class:[_vm.$style.mediaLink, _vm.$style.videoLink],attrs:{"aria-label":"goto detail"},on:{"click":function($event){_vm.isModalOpen = true;
      _vm.wtParams &&
        _vm.wtTrack(
          { cat: _vm.wtParams.doctype },
          _vm.mergeWtParams(
            _vm.wtParams,
            {
              filename: _vm.primaryLink
            },
            {}
          )
        );}}},[_c('i',{staticClass:"fab fa-youtube"}),_c('img',{attrs:{"src":_vm.image,"alt":_vm.linkTitle}})]):_vm._e(),(!_vm.isVideo)?_c('a',{class:_vm.$style.mediaLink,attrs:{"href":_vm.primaryLink,"target":_vm.primaryLinkNewWindow ? '_blank' : '_self'},on:{"click":function($event){_vm.wtParams &&
        _vm.wtTrack(
          { cat: _vm.wtParams.doctype },
          _vm.mergeWtParams(
            _vm.wtParams,
            {
              filename: _vm.primaryLink
            },
            {}
          )
        )}}},[_c('img',{attrs:{"src":_vm.image,"alt":""}})]):_vm._e(),_c('figcaption',[(_vm.category)?_c('a',{class:_vm.$style.secondaryLink,attrs:{"href":_vm.secondaryLink,"target":_vm.secondaryLinkNewWindow ? '_blank' : '_self'}},[_vm._v("\n      "+_vm._s(_vm.category)+"\n    ")]):_vm._e(),(_vm.isVideo && _vm.linkTitle)?_c('a',{class:_vm.$style.primaryLink,on:{"click":function($event){_vm.isModalOpen = true;
        _vm.wtParams &&
          _vm.wtTrack(
            { cat: _vm.wtParams.doctype },
            _vm.mergeWtParams(
              _vm.wtParams,
              {
                filename: _vm.primaryLink
              },
              {}
            )
          );}}},[_vm._v("\n      "+_vm._s(_vm.linkTitle)+"\n    ")]):_vm._e(),(!_vm.isVideo && _vm.linkTitle)?_c('a',{class:_vm.$style.primaryLink,attrs:{"href":_vm.primaryLink,"target":_vm.primaryLinkNewWindow ? '_blank' : '_self'},on:{"click":function($event){_vm.wtParams &&
          _vm.wtTrack(
            { cat: _vm.wtParams.doctype },
            _vm.mergeWtParams(
              _vm.wtParams,
              {
                filename: _vm.primaryLink
              },
              {}
            )
          )}}},[_vm._v("\n      "+_vm._s(_vm.linkTitle)+"\n    ")]):_vm._e()]),(_vm.isVideo)?_c('Modal',{attrs:{"isModalOpen":_vm.isModalOpen,"isVideo":_vm.isVideo},on:{"closeModal":function($event){_vm.isModalOpen = false}}},[(_vm.isModalOpen)?_c('iframe',{attrs:{"src":_vm.primaryLink,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}}):_vm._e()]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }